import { Outlet, useLocation } from "react-router";

import { RouteAnalytics } from "@/components/analytics/RouteAnalytics";
import { DisclosureFooter } from "@/components/layout/DisclosureFooter";
import { Footer } from "@/components/layout/Footer";
import { Header } from "@/components/layout/Header";
import { PageContainer } from "@/components/layout/PageContainer";
import { RouteErrorBoundary } from "@/components/layout/RouteErrorBoundary";
import { TenantThemeProvider } from "@/components/tenant/TenantThemeProvider";

// Vite equivalent of `app/app/layout.tsx`. Same visual structure (Header,
// PageContainer, Footer) but mounted via react-router <Outlet/> instead of
// Next.js's nested children. The `<html>`/`<body>` chrome lives in
// `index.html` for Vite. TenantThemeProvider wraps the chrome the same way
// layout.tsx wired it in the Next tree (SFWL-002 white-label theming).
export function AppShell() {
  const location = useLocation();

  return (
    <TenantThemeProvider>
      <div className="flex min-h-screen flex-col bg-slate-50 text-slate-900 antialiased">
        <RouteAnalytics />
        <Header />
        <PageContainer>
          {/* FEAT-003: RouteErrorBoundary wraps only the routed page tree —
              Header/Footer/DisclosureFooter stay mounted (and the reload
              button in the fallback stays reachable) if a route throws.
              Keyed on the pathname so navigating to a different route remounts
              the boundary — otherwise `hasError` stays true forever and every
              route after the crashed one shows the fallback until a hard
              reload. */}
          <RouteErrorBoundary key={location.pathname}>
            <Outlet />
          </RouteErrorBoundary>
        </PageContainer>
        <Footer />
        <DisclosureFooter />
      </div>
    </TenantThemeProvider>
  );
}
